// Use PostgreSQL query (not AWS Amplify query)
// PostgreSQL schema doesn't have 'id' parameter - it uses filter instead
import { listClientUsers as listClientUsersGQL } from '../../../graphql/queries';
import { queryGqlApi } from "../../../graphql/queryGqlApi";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';


export const listClientUsers = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    nextToken?: string,
    limit?: number
): Promise<any> => {
    return queryGqlApi(
        listClientUsersGQL,
        {
            limit: limit,
            nextToken: nextToken
            // Note: No 'id' parameter - PostgreSQL resolver handles ownerId filtering server-side
        },
        dataClientService,
        authService,
        'pgServer'
    );
}
